"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var codec_1 = require("../../codec");
exports.bank = __importStar(require("./module"));
__export(require("./types"));
// Register codec
codec_1.codec.registerCodec("cosmos-sdk/MsgSend", types_1.MsgSend, types_1.MsgSend.fromJSON);
codec_1.codec.registerCodec("cosmos-sdk/MsgMultiSend", types_1.MsgMultiSend, types_1.MsgMultiSend.fromJSON);
